import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100vw',
    height: '100vh',
    cursor: 'pointer',
    textAlign: 'center',
  },
  cardRoot: {
    marginBottom: theme.spacing(4),
  },
  thread: {
    marginTop: theme.spacing(4),
  },
  contentDetails: {
    fontSize: '3.5vw',
  },
  title: {
    fontSize: '5.5vw',
  },
  pictoLogo: {
    bottom: 0,
    width: '24vw',
    marginRight: '1vw',
  },
  bottomContainer: {
    display: 'flex',
    width: '100%',
    zIndex: 100,
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(0.5),
    [theme.breakpoints.down(390)]: {
      marginTop: theme.spacing(1),
    },
  },
  pictoLogoLink: {
    paddingBottom: 0,
    marginBottom: 0,
    marginTop: theme.spacing(2),
  },
  linkLabel: {
    textDecoration: 'none',
    color: theme.palette.common.black,
    fontSize: '3vw',
    fontWeight: 800,
    marginTop: theme.spacing(2),
    borderBottom: '3px solid black',
  },
  contentRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    paddingLeft: theme.spacing(2),
  },
  pictureRoot: {
    display: 'flex',
    justifyContent: 'center',
  },
}))

export default useStyles
